export default __webpack_public_path__ + "static/media/themebel_mobile_small.5ae74ec0.svg";